 /*============Teaser Controller
  ================================*/
  angular
    .module('vppApp')
    .controller('teaserController', teaserController);

  teaserController.$inject = ['$scope', '$rootScope', 'teaserFactory', 'apiFactory', '$window', 'AuthenticationService', '$cookies'];

  function teaserController($scope, $rootScope, teaserFactory, apiFactory, $window, AuthenticationService, $cookies){

    $scope.isAuth = AuthenticationService.isAuthenticated();
    $scope.isAuthent = function () {
      return AuthenticationService.isAuthenticated();
    };

    $scope.gcSignIn = function() {
      apiFactory.gcVerify()
        .then(function successGCSignIn(response){
          if(response.data.url != null){
            var date = new Date();
            var expirationDate = new Date(date.setMonth(date.getMonth()+6));
            $cookies.put('createAccountDirect', false, {expires: expirationDate});

            $window.location.href = response.data.url;
          }else{
            $location.path("/saml/login/" + response.data.accountId);
          }
        }, function errorCallback(response){
          console.log(response.data.errors);
          $scope.serverError = response.data.errors;
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        });
    };

    teaserFactory().then(function (response) {
      $scope.component = response.data.components;
      $scope.teasers = $scope.component.teasers;
      $scope.items = $scope.teasers.items;
      $scope.cta = $scope.items.link;
    });

  };
